var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.472 -431.729)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 497",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(18.472 431.729)",
    style: {
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "ic_lock"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 371",
    d: "M449.8 2009.025h-1.25v-2.872a3.781 3.781 0 0 0-1.171-2.669c-.082-.08-.178-.141-.266-.212l-.038-.03a3.744 3.744 0 0 0-.588-.379l-.01-.005a3.712 3.712 0 0 0-.67-.267l-.019-.006a3.8 3.8 0 0 0-.705-.13l-.046-.005c-.1-.006-.193-.027-.291-.027h-.081a3.8 3.8 0 0 0-3.73 3.73v2.871h-1.248a2.131 2.131 0 0 0-2.123 2.124v7.163a2.129 2.129 0 0 0 2.123 2.123H449.8a2.128 2.128 0 0 0 2.123-2.123v-7.163a2.129 2.129 0 0 0-2.123-2.123zm-7.431-2.871a2.377 2.377 0 0 1 2.372-2.3h.076a2.377 2.377 0 0 1 2.3 2.3v2.871h-4.744zm8.117 12.159a.686.686 0 0 1-.2.487.677.677 0 0 1-.486.2h-10.11a.689.689 0 0 1-.687-.687v-7.167a.689.689 0 0 1 .687-.686h10.11a.687.687 0 0 1 .686.686z",
    transform: "translate(-410.274 -1563.699)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 372",
    d: "M447.857 2017.636a1.541 1.541 0 0 0-.975 2.735v1.322a.975.975 0 0 0 1.95 0v-1.322a1.541 1.541 0 0 0-.975-2.735zm.512 2.331-.137.089v1.638a.375.375 0 1 1-.75 0v-1.638l-.137-.089a.942.942 0 1 1 1.024 0z",
    transform: "translate(-413.386 -1569.046)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.2e60cc33e40db801c668a117c8a40858.svg";
export { ForwardRef as ReactComponent };